<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedItem" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('seller') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedItem }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('seller') }}
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('seller').toLowerCase() }}
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="sellers.length > 0")
          div(v-for="seller in sellers" :key="seller.value")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(seller)")
              yc-checkbox(v-model="seller.checked" @change="uncheckOthers(seller)")
              .ml-4 {{ seller.label }}
            v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No sellers found
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  props: ['filter'],
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    sellers: [],
    // checkedItem: null,
    selectedItem: null,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    checkedItem () {
      let item = null
      let seller = this.sellers.find(f => f.checked)
      if (seller) {
        item = seller
      }
      return item
    },
    disabledButton () {
      return !this.checkedItem
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.fetchSellers()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSellers () {
      this.isLoading = true
      const params = {
        field: 'medication.sold_by',
        page_size: -1,
        search: this.searchText || ''
      }
      this.$axios.get(`/options?company=${this.company.id}`, { params })
      .then(resp => {
        if (resp.data?.results) {
          this.sellers = resp.data.results.map(item => {
            return {
              label: item.value,
              value: `${item.value}`,
              checked: false
            }
          })
        } else {
          this.sellers = []
        }
        // this.checkedItem = null
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      // this.checkedItem = null
      this.sellers.map(m => m.checked = false)
      this.selectedItem = null
    },
    apply () {
      this.showMenu = false
      this.selectedItem = this.checkedItem.value
      this.$emit('update:filter', { key: 'seller', value: this.checkedItem.value})
    },
    clickItem (item) {
      this.sellers.map(m => m.checked = false)
      item.checked = true
    },
    uncheckOthers (item) {
      this.sellers.filter(f => f.value != item.value).map(m => m.checked = false)
    },
    queryChanged: debounce(function () {
      this.fetchSellers()
    }, 750),
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>